import { Toaster as Sonner } from "sonner"

const Toaster = (props) => {
  const theme = "light"

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      toastOptions={{
        icons: {
          success: null,
          error: null,
          warning: null,
          info: null,
        },
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-white group-[.toaster]:text-gray-950 group-[.toaster]:border-gray-200 group-[.toaster]:shadow-lg group-[.toaster]:rounded-lg group-[.toaster]:border group-[.toaster]:border-[#E4E4E7]",
          description: "group-[.toast]:text-gray-500",
          actionButton:
            "group-[.toast]:bg-gray-900 group-[.toast]:text-gray-50",
          cancelButton:
            "group-[.toast]:bg-gray-100 group-[.toast]:text-gray-500",
        },
      }}
      position="top-right"
      {...props}
    />
  )
}

export { Toaster }

